<template>
    <div>
      <!-- 现存主要健康问题 -->
        <xr-collapse class="single-collapse">
          <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
            <el-tab-pane label="现存主要健康问题">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="脑血管疾病">
                    <el-checkbox v-model="formData.cvdUndiscovered" :true-label="'1'" :false-label="'0'" @change="handleCvdUndiscoveredChange">未发现</el-checkbox>
                    <el-checkbox v-model="formData.cvdIschemicStroke" :true-label="'1'" :false-label="'0'" :disabled="formData.cvdUndiscovered === 1">缺血性卒中</el-checkbox>
                    <el-checkbox v-model="formData.cvdCerebralHemorrhage" :true-label="'1'" :false-label="'0'" :disabled="formData.cvdUndiscovered === 1">脑出血</el-checkbox>
                    <el-checkbox v-model="formData.cvdSah" :true-label="'1'" :false-label="'0'" :disabled="formData.cvdUndiscovered === 1">蛛网膜下腔出血</el-checkbox>
                    <el-checkbox v-model="formData.cvdTia" :true-label="'1'" :false-label="'0'" :disabled="formData.cvdUndiscovered === 1">短暂性脑缺血发作</el-checkbox>
                    <el-checkbox v-model="formData.cvdOthers" :true-label="'1'" :false-label="'0'" :disabled="formData.cvdUndiscovered === 1">其他</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item>
                    <el-input v-model="formData.cvdOthersStr" :disabled="formData.cvdUndiscovered === 1"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 肾脏疾病 -->
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="肾脏疾病">
                    <el-checkbox v-model="formData.renalUndiscovered" :true-label="'1'" :false-label="'0'" @change="handleRenalUndiscoveredChange">未发现</el-checkbox>
                    <el-checkbox v-model="formData.renalDn" :true-label="'1'" :false-label="'0'" :disabled="formData.renalUndiscovered === 1">糖尿病肾病</el-checkbox>
                    <el-checkbox v-model="formData.renalFailure" :true-label="'1'" :false-label="'0'" :disabled="formData.renalUndiscovered === 1">肾功能衰竭</el-checkbox>
                    <el-checkbox v-model="formData.renalAgn" :true-label="'1'" :false-label="'0'" :disabled="formData.renalUndiscovered === 1">急性肾炎</el-checkbox>
                    <el-checkbox v-model="formData.renalCgn" :true-label="'1'" :false-label="'0'" :disabled="formData.renalUndiscovered === 1">慢性肾炎</el-checkbox>
                    <el-checkbox v-model="formData.renalOthers" :true-label="'1'" :false-label="'0'" :disabled="formData.renalUndiscovered === 1">其他</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item>
                    <el-input v-model="formData.renalOthersStr" :disabled="formData.renalUndiscovered === 1"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 心脏疾病 -->
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="心脏疾病">
                    <el-checkbox v-model="formData.heartUndiscovered" :true-label="'1'" :false-label="'0'" @change="handleHeartUndiscoveredChange">未发现</el-checkbox>
                    <el-checkbox v-model="formData.heartMyocardialInfarction" :true-label="'1'" :false-label="'0'" :disabled="formData.heartUndiscovered === 1">心肌梗死</el-checkbox>
                    <el-checkbox v-model="formData.heartAnginaPectoris" :true-label="'1'" :false-label="'0'" :disabled="formData.heartUndiscovered === 1">心绞痛</el-checkbox>
                    <el-checkbox v-model="formData.heartCoronaryArtery" :true-label="'1'" :false-label="'0'" :disabled="formData.heartUndiscovered === 1">冠状动脉血运重建</el-checkbox>
                    <el-checkbox v-model="formData.heartChf" :true-label="'1'" :false-label="'0'" :disabled="formData.heartUndiscovered === 1">充血性心力衰竭</el-checkbox>
                    <el-checkbox v-model="formData.heartPrecordialpain" :true-label="'1'" :false-label="'0'" :disabled="formData.heartUndiscovered === 1">心前区疼痛</el-checkbox>
                    <el-checkbox v-model="formData.cHeartDis" :true-label="'1'" :false-label="'0'" :disabled="formData.heartUndiscovered === 1">冠心病</el-checkbox>
                    <el-checkbox v-model="formData.heartOthers" :true-label="'1'" :false-label="'0'" :disabled="formData.heartUndiscovered === 1">其他</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item>
                    <el-input v-model="formData.heartOthersStr" :disabled="formData.heartUndiscovered === 1"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 血管疾病 -->
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="血管疾病">
                    <el-checkbox v-model="formData.angiosisUndiscovered" :true-label="'1'" :false-label="'0'" @change="handleAngiosisUndiscoveredChange">未发现</el-checkbox>
                    <el-checkbox v-model="formData.hypertension" :true-label="'1'" :false-label="'0'" :disabled="formData.angiosisUndiscovered === 1">高血压</el-checkbox>
                    <el-checkbox v-model="formData.angiosisDa" :true-label="'1'" :false-label="'0'" :disabled="formData.angiosisUndiscovered === 1">夹层动脉瘤</el-checkbox>
                    <el-checkbox v-model="formData.angiosisOcclusionArteries" :true-label="'1'" :false-label="'0'" :disabled="formData.angiosisUndiscovered === 1">动脉闭塞性疾病</el-checkbox>
                    <el-checkbox v-model="formData.angiosisOthers" :true-label="'1'" :false-label="'0'" :disabled="formData.angiosisUndiscovered === 1">其他</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item>
                    <el-input v-model="formData.angiosisOthersStr" :disabled="formData.angiosisUndiscovered === 1"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 眼部疾病 -->
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="眼部疾病">
                    <el-checkbox v-model="formData.eyeDiseaseUndiscovered" :true-label="'1'" :false-label="'0'" @change="handleEyeDiseaseUndiscoveredChange">未发现</el-checkbox>
                    <el-checkbox v-model="formData.retinalHemorrhage" :true-label="'1'" :false-label="'0'" :disabled="formData.eyeDiseaseUndiscovered === 1">网膜出血或渗出</el-checkbox>
                    <el-checkbox v-model="formData.papilledema" :true-label="'1'" :false-label="'0'" :disabled="formData.eyeDiseaseUndiscovered === 1">视乳头水肿</el-checkbox>
                    <el-checkbox v-model="formData.eyeDiseaseCataract" :true-label="'1'" :false-label="'0'" :disabled="formData.eyeDiseaseUndiscovered === 1">白内障</el-checkbox>
                    <el-checkbox v-model="formData.eyeDiseaseOthers" :true-label="'1'" :false-label="'0'" :disabled="formData.eyeDiseaseUndiscovered === 1">其他</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item>
                    <el-input v-model="formData.eyeDiseaseOthersStr"  :disabled="formData.eyeDiseaseUndiscovered === 1"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 神经系统疾病 -->
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="神经系统疾病" label-width="130px">
                    <el-radio-group v-model="formData.nervousSystemDisease" style="display: flex; align-items: center; flex-wrap: wrap;">
                      <el-radio label="1" @change="handleNervousSystemDiseaseChange" style="display: flex; align-items: center;">未见异常</el-radio>
                      <el-radio label="2" style="display: flex; align-items: center; margin-left: 20px;">
                        <span style="margin-right: 8px;">有</span>
                        <el-input v-model="formData.nervousSystemDiseaseStr" placeholder="异常" :disabled="formData.nervousSystemDisease === '1'" style="width: 150px;"></el-input>
                      </el-radio>
                      <el-radio label="3" style="display: flex; align-items: center; margin-left: 20px;">严重精神障碍</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 内分泌系统疾病 -->
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="内分泌系统疾病" label-width="130px">
                    <el-radio-group v-model="formData.enmedis">
                      <el-radio  :label="'1'" @change="handleEnmedisChange">未见异常</el-radio>
                      <el-radio  :label="'2'">糖尿病</el-radio>
                      <el-radio  :label="'3'">其他</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <el-input v-model="formData.enmedisOther" placeholder="异常" :disabled="formData.enmedis === '1'"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 其他系统疾病 -->
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="其他系统疾病" label-width="130px">
                    <el-radio-group v-model="formData.otherDiseaseNo">
                      <el-radio  :label="'1'" @change="handleOtherDiseaseNoChange">未发现</el-radio>
                      <el-radio  :label="'2'">有</el-radio>
                      <el-radio  :label="'3'">其他</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <el-input v-model="formData.otherDiseaseStr" placeholder="异常" :disabled="formData.otherDiseaseNo === '1'"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-tab-pane>
          </el-tabs>
        </xr-collapse>


      <!-- 住院治疗情况 -->
      <xr-collapse class="single-collapse">
       <el-tabs  type="border-card"  style="width: 100%;height: 100%;" class="single-tabs">
         <el-tab-pane label="住院治疗情况">
           <!-- 住院史 -->
           <div class="section-title">
              <i class="el-icon-menu" style="margin-right: 10px;"></i>住院史
              <el-checkbox v-model="formData.inhospital" :true-label="'1'" :false-label="'0'" style="margin-left: 10px;">无</el-checkbox>
              <el-divider></el-divider>
           </div>

           <el-table :data="inhospitalList" border style="width: 100%; margin-bottom: 20px;">
             <el-table-column label="入院日期" header-align="center">
                <template slot-scope="scope">
                  <el-date-picker v-model="formData['inhospitalAdmissionDate' + (scope.$index + 1)]" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"  :disabled="formData.inhospital === '1'"></el-date-picker>
                </template>
             </el-table-column>
             <el-table-column label="出院日期" header-align="center">
                <template slot-scope="scope">
                    <el-date-picker v-model="formData['inhospitalLeaveDate' + (scope.$index + 1)]" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"  :disabled="formData.inhospital === '1'"></el-date-picker>
                </template>
             </el-table-column>
             <el-table-column label="原因" header-align="center" >
                <template slot-scope="scope">
                    <el-input v-model="formData['inhospitalCause' + (scope.$index + 1)]" placeholder="原因"  :disabled="formData.inhospital === '1'"></el-input>
                </template>
             </el-table-column>
             <el-table-column label="医疗机构名称" header-align="center" >
                <template slot-scope="scope">
                  <el-input v-model="formData['inhospitalOrgName' + (scope.$index + 1)]" placeholder="机构"  :disabled="formData.inhospital === '1'"></el-input>
                </template>
              </el-table-column>
             <el-table-column label="病案号" header-align="center" >
               <template slot-scope="scope">
                 <el-input v-model="formData['inhospitalPatientId' + (scope.$index + 1)]"   placeholder="病案号" :disabled="formData.inhospital === '1'"></el-input>
               </template>
               </el-table-column>
             <el-table-column label="操作" header-align="center"   width="100px">
               <template slot-scope="scope">
                 <el-button type="primary" icon="el-icon-delete" size="mini" @click="removeInhospitalRow(scope.$index)"></el-button>
               </template>
             </el-table-column>
           </el-table>

           <!-- 家庭病床史 -->
           <div class="section-title">
              <i class="el-icon-menu" style="margin-right: 10px;"></i>家庭病床史
              <el-checkbox v-model="formData.fpHistory" :true-label="'1'" :false-label="'0'" style="margin-left: 10px;">无</el-checkbox>
              <el-divider></el-divider>
           </div>

           <el-table :data="fpList" border style="width: 100%; margin-bottom: 20px;">
             <el-table-column label="建床日期" header-align="center" >
               <template slot-scope="scope">
                 <el-date-picker v-model="formData['fpEstablishDate' + (scope.$index + 1)]" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"  :disabled="formData.fpHistory === '1'"></el-date-picker>
               </template>
             </el-table-column>
             <el-table-column label="撤床日期" header-align="center" >
               <template slot-scope="scope">
                 <el-date-picker v-model="formData['fpCancelDate' + (scope.$index + 1)]" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="formData.fpHistory === '1'"></el-date-picker>
               </template>
             </el-table-column>
             <el-table-column label="原因" header-align="center" >
               <template slot-scope="scope">
                 <el-input v-model="formData['fpCause' + (scope.$index + 1)]" placeholder="原因"  :disabled="formData.fpHistory === '1'"></el-input>
               </template>
             </el-table-column>
             <el-table-column label="医疗机构名称" header-align="center" >
               <template slot-scope="scope">
                 <el-input v-model="formData['fpOrgName' + (scope.$index + 1)]" placeholder="机构"   :disabled="formData.fpHistory === '1'"></el-input>
               </template>
             </el-table-column>
             <el-table-column label="病案号" header-align="center" >
               <template slot-scope="scope">
                 <el-input v-model="formData['fpPatientId' + (scope.$index + 1)]" placeholder="病案号" :disabled="formData.fpHistory === '1'"></el-input>
               </template>
             </el-table-column>
             <el-table-column label="操作" header-align="center"  width="100px">
               <template slot-scope="scope">
                 <el-button type="primary" icon="el-icon-delete" size="mini" @click="removeFpRow(scope.$index)"></el-button>
               </template>
             </el-table-column>
           </el-table>
         </el-tab-pane>
       </el-tabs>
      </xr-collapse>


      <!-- 主要用药情况 -->
      <xr-collapse class="single-collapse">
        <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
          <el-tab-pane label="主要用药情况">
            <el-table :data="[1,2,3,4,5,6]" border style="width: 100%; margin-bottom: 20px;">
              <el-table-column label="药物名称" header-align="center" align="center"><template slot-scope="scope">
                <div class="flex-center">
                  <el-select v-model="formData['drugName' + (scope.$index + 1)]" placeholder="药物名称" style="width: 100%;">
                    <el-option v-for="item in drugNameDict" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'DRUG_NAME_DICT')"></el-button>
                </div>
              </template></el-table-column>
              <el-table-column label="用法" header-align="center" align="center">
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <el-select v-model="formData['drugUsage' + (scope.$index + 1)]" placeholder="用法" style="width: 100%;">
                        <el-option v-for="item in drugUsageDict" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'DRUG_USAGE_DICT')"></el-button>
                    </div>
                  </template>
              </el-table-column>
              <el-table-column label="用量" header-align="center" align="center">
                <template slot-scope="scope">
                  <div class="flex-center">
                    <el-select v-model="formData['drugDosage' + (scope.$index + 1)]" placeholder="用量" style="width: 100%;">
                      <el-option v-for="item in drugDosageDict":key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'DRUG_DOSAGE_DICT')"></el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="用药时间" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-input v-model="formData['drugDate' + (scope.$index + 1)]" placeholder="用药时间" style="width: 100%;"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="服药依从性" header-align="center" align="center">
                <template slot-scope="scope">
                    <el-radio-group v-model="formData['drugCompliance' + (scope.$index + 1)]">
                      <el-radio label="1">规律</el-radio>
                      <el-radio label="2">间隔</el-radio>
                      <el-radio label="3">不服药</el-radio>
                    </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column label="操作" header-align="center" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-delete" size="mini" @click="removeDrugRow(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </xr-collapse>

       <!-- 非免疫规划预防接种史 -->
      <xr-collapse class="single-collapse">
        <el-tabs type="border-card" style="width: 100%;height: 100%;" class="single-tabs">
          <el-tab-pane label="非免疫规划预防接种史">
            <el-table :data="niVaccinationList" border style="width: 100%; margin-bottom: 20px;">
              <el-table-column label="名称" header-align="center" align="center">
                <template slot-scope="scope">
                  <div class="flex-center">
                      <el-select v-model="formData['niVaccinationName' + (scope.$index + 1)]" placeholder="名称" style="width: 100%;">
                        <el-option v-for="item in niVaccinationNameDict" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                      <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'NI_VACCINATION_NAME_DICT')"></el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="接种日期" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-date-picker v-model="formData['niVaccinationDate' + (scope.$index + 1)]" type="date" value-format="yyyy-MM-dd" placeholder="接种日期" style="width: 100%;"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="接种机构" header-align="center" align="center">
                <template slot-scope="scope">
                  <div class="flex-center">
                      <el-select v-model="formData['niVaccinationOrg' + (scope.$index + 1)]" placeholder="机构" style="width: 100%;">
                        <el-option v-for="item in medicalOrgNameDict" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                      </el-select>
                      <el-button icon="el-icon-setting" size="mini" class="maintain-btn el-button--text" @click="$emit('openDictDialog', 'MEDICAL_ORGNAME_DICT')"></el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" header-align="center" align="center" width="100px">
                <template slot-scope="scope">
                  <el-button type="primary" icon="el-icon-delete" size="mini" @click="removeNiVaccinationRow(scope.$index)" ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </xr-collapse>
    </div>
</template>

<script>
  export default {
    name: 'MedicalOther',
    props: {
      formData: {
        type: Object,
        required: true
      },
      drugNameDict: {
        type: Array,
        default: () => []
      },
      drugUsageDict: {
        type: Array,
        default: () => []
      },
      drugDosageDict: {
        type: Array,
        default: () => []
      },
      niVaccinationNameDict: {
        type: Array,
        default: () => []
      },
      medicalOrgNameDict: {
        type: Array,
        default: () => []
      },
      hazardOthersDict: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        inhospitalList: [1, 2],
        fpList: [1, 2],
        drugList: [1, 2, 3, 4, 5, 6],
        niVaccinationList: [1, 2, 3]
      }
    },
    methods: {
      //删除住院史行
      removeInhospitalRow(index) {
        if (this.inhospitalList.length > 1) {
          this.inhospitalList.splice(index, 1)
        }
      },
      //删除家庭病床史行
      removeFpRow(index) {
        if (this.fpList.length > 1) {
          this.fpList.splice(index, 1)
        }
      },
      //删除主要用药情况行
      removeDrugRow(index) {
        if (this.drugList.length > 1) {
          this.drugList.splice(index, 1)
        }
      },
      //删除非免疫规划预防接种史行
      removeNiVaccinationRow(index) {
        if (this.niVaccinationList.length > 1) {
          this.niVaccinationList.splice(index, 1)
        }
      },
      //处理脑血管疾病未发现状态变化
      handleCvdUndiscoveredChange(val) {
        if (val === 1) {
          this.formData.cvdIschemicStroke = 0;
          this.formData.cvdCerebralHemorrhage = 0;
          this.formData.cvdSah = 0;
          this.formData.cvdTia = 0;
          this.formData.cvdOthers = 0;
          this.formData.cvdOthersStr = '';
        }
      },
      //处理肾脏疾病未发现状态变化
      handleRenalUndiscoveredChange(val) {
        if (val === 1) {
          this.formData.renalDn = 0;
          this.formData.renalFailure = 0;
          this.formData.renalAgn = 0;
          this.formData.renalCgn = 0;
          this.formData.renalOthers = 0;
          this.formData.renalOthersStr = '';
        }
      },
      //处理心脏疾病未发现状态变化
      handleHeartUndiscoveredChange(val) {
        if (val === 1) {
          this.formData.heartMyocardialInfarction = 0;
          this.formData.heartAnginaPectoris = 0;
          this.formData.heartCoronaryArtery = 0;
          this.formData.heartChf = 0;
          this.formData.heartPrecordialpain = 0;
          this.formData.cHeartDis = 0;
          this.formData.heartOthers = 0;
          this.formData.heartOthersStr = '';
        }
      },
      //处理血管疾病未发现状态变化
      handleAngiosisUndiscoveredChange(val) {
        if (val === 1) {
          this.formData.hypertension = 0;
          this.formData.angiosisDa = 0;
          this.formData.angiosisOcclusionArteries = 0;
          this.formData.angiosisOthers = 0;
          this.formData.angiosisOthersStr = '';
        }
      },
      //处理眼部疾病未发现状态变化
      handleEyeDiseaseUndiscoveredChange(val) {
        if (val === 1) {
          this.formData.retinalHemorrhage = 0;
          this.formData.papilledema = 0;
          this.formData.eyeDiseaseCataract = 0;
          this.formData.eyeDiseaseOthers = 0;
          this.formData.eyeDiseaseOthersStr = '';
        }
      },
      //处理神经系统疾病状态变化
      handleNervousSystemDiseaseChange(val) {
        if (val === 1) {
          this.formData.nervousSystemDiseaseStr = '';
        }
      },
      //处理内分泌系统疾病状态变化
      handleEnmedisChange(val) {
        if (val === 1) {
          this.formData.enmedisOther = '';
        }
      },
      //处理其他系统疾病状态变化
      handleOtherDiseaseNoChange(val) {
        if (val === 1) {
          this.formData.otherDiseaseStr = '';
        }
      }
    }
  }
  </script>

  <style scoped>
  .section-title {
    margin-left: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 15px;
    color: #000;
  }
  .el-table >>> .el-table__header th {
    color: #000;
  }
  .maintain-btn{
    padding: 5px 10px;
    height: auto;
    margin-left: 5px;
  }
  .el-button--text {
      border-color: transparent;
      color: #1890ff;
      background: transparent;
      padding-left: 0;
      padding-right: 0;
  }
  .flex-center{
    display: flex;
    align-items: center;
  }
  </style>



// WEBPACK FOOTER //
// src/views/ph/archive/medical/medical-problems.vue